import {Component, OnInit, TemplateRef} from '@angular/core';
import {SharedResources} from "../../../shared-resources";
import {APIHelper} from "../../../apihelper";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Products} from "../../../models/products";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {CustomValidatorsService} from "../../../customvalidators.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-edit-product',
  templateUrl: './edit-product.component.html',
  styleUrls: ['./edit-product.component.css']
})
export class EditProductComponent implements OnInit {
  product: Products = new Products();
  countries: any = [];
  greenstamps: any = [];
  productsForm = new FormGroup(
    {
      Id: new FormControl(''),
      Vendor: new FormControl('',
        [
          Validators.required
        ]),
      PartNo: new FormControl('',
        [
          Validators.required
        ]),
      Eccn: new FormControl('',
        [
          Validators.pattern('(^[A-Z]{3}[0-9]{2}$)|(^[0-9][A-Z][0-9]{3}$)|(^[0-9][A-Z][0-9]{3}\\.[a-z]\\.[0-9]$)|(^[0-9][A-Z][0-9]{3}\\.[a-z]$)'),
          Validators.required
        ]),
      HsCode: new FormControl('',
        [
          Validators.pattern('^[0-9]{8}$'),
          Validators.required
        ]),
      TaraOrigine: new FormControl('',
        [
          Validators.required
        ]),
      CategorieTimbruVerde: new FormControl('',
        [
          Validators.required
        ])
    }
  )
  numberOfPartPages: number = 0;
  currentPartPage: number = 0;
  parts: any = [];
  currentPartName: string = '';

  constructor(private http: HttpClient, private customValidators: CustomValidatorsService, private modalService: NgbModal) {
  }

  ngOnInit(): void {
    this.product = SharedResources.currentEditProduct;
    this.productsForm.controls.Id.setValue(this.product.Id);
    this.productsForm.controls.Vendor.setValue(this.product.Vendor);
    this.productsForm.controls.PartNo.setValue(this.product.PartNo);
    this.productsForm.controls.Eccn.setValue(this.product.Eccn);
    this.productsForm.controls.HsCode.setValue(this.product.HsCode);
    this.productsForm.controls.CategorieTimbruVerde.setValue(this.product.CategorieTimbruVerde);
    this.http.get<any>(`${APIHelper.APIUrl}country`,
      {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('token')}`
        })
      }).subscribe(
      (response: any) => {
        this.countries = response.map((t : any) => t.Nume + ' (' + t.Cod + ')').sort((t1: any, t2: any) => {
          return t1.localeCompare(t2);
        });
        this.productsForm.controls.TaraOrigine.setValue(this.product.TaraOrigine);
      }, (error: any) => {
        alert("Eroare la încărcarea țărilor!");
        SharedResources._isLoadingBS.next(false);
      });
    this.http.get<any>(`${APIHelper.APIUrl}part?productId=${this.product.Id}`,
      {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('token')}`
        })
      }).subscribe(
      (response: any) => {
        this.parts = response.map((r : any) => r.Nume);
      }, (error: any) => {
        alert("Eroare la încărcarea pieselor!");
        SharedResources._isLoadingBS.next(false);
      });


    this.http.get<any>(`${APIHelper.APIUrl}greenstamp`,
      {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('token')}`
        })
      }).subscribe(
      (response: any) => {
        this.greenstamps = response.map((gs : any) => gs.Nume).sort((gs1: any, gs2: any) => {
          return gs1.localeCompare(gs2);
        });
        this.productsForm.controls.CategorieTimbruVerde.setValue(this.product.CategorieTimbruVerde);
      }, (error: any) => {
        alert("Eroare la încărcarea timbrelor verzi!");
        SharedResources._isLoadingBS.next(false);
      });
  }

  cancelEditProduct() {
    SharedResources.currentScreen = 'products';
    SharedResources._currentScreenBS.next(SharedResources.currentScreen);
  }

  saveProduct(editProductForm: any) {
    SharedResources._isLoadingBS.next(true);
    this.http.put<any>(`${APIHelper.APIUrl}product`,
      editProductForm.value,
      {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('token')}`
        })
      }).subscribe(
      (response: any) => {
        this.http.put<any>(`${APIHelper.APIUrl}part`,
          {
            PartNo : this.productsForm.controls.PartNo.value,
            PartNames : this.parts
          },
          {
            headers: new HttpHeaders({
              "Content-Type": "application/json",
              "Authorization": `Bearer ${localStorage.getItem('token')}`
            })
          }).subscribe(
          (response: any) => {
            SharedResources._isLoadingBS.next(false);
            SharedResources._currentScreenBS.next('products');
            alert("Produs modificat cu succes!");
          },(error: any) => {
            SharedResources._isLoadingBS.next(false);
            SharedResources._currentScreenBS.next('products');
            alert("Eroare la salvarea pieselor!");
          });
      }, (error: any) => {
        alert(error.error);
        SharedResources._isLoadingBS.next(false);
      });
  }

  goToNextPage() {
    this.currentPartPage++;
    if (this.currentPartPage > this.numberOfPartPages)
      this.currentPartPage = 1;
  }

  goToPrevPage() {
    this.currentPartPage--;
    if (this.currentPartPage <= 0)
      this.currentPartPage = this.numberOfPartPages;
  }

  deletePart(part: string) {
    this.parts = this.parts.filter((p : any) => p.toUpperCase() != part.toUpperCase());
    this.numberOfPartPages = this.parts.length % 5 == 0 ?
      Math.floor(this.parts.length / 5) : (Math.floor(this.parts.length / 5) + 1);
    if (this.currentPartPage > this.numberOfPartPages)
      this.currentPartPage = 1;
  }

  applyPartsModifications(modalParts: any) {
    modalParts.dismiss();
  }

  modifyParts(modalParts: TemplateRef<any>) {
    this.currentPartName = '';
    this.currentPartPage = 1;
    this.numberOfPartPages = this.parts.length % 5 == 0 ?
      Math.floor(this.parts.length / 5) : (Math.floor(this.parts.length / 5) + 1);

    this.modalService.open(modalParts, {
      ariaLabelledBy: 'modal-basic-title',
      backdrop: 'static',
      keyboard: false
    }).result.then(
      (result) => {
      },
      (reason) => {
      });
  }

  getParts() {
    return this.parts.filter((value : any, index : any) => (index >= (this.currentPartPage - 1) * 5 && index < this.currentPartPage * 5));
  }

  addPart() {
    if (this.parts.map((p : any) => p.toUpperCase()).includes(this.currentPartName.toUpperCase())) {
      alert("Piesa a mai fost introdusă!");
      return;
    }
    if (this.currentPartName == '') {
      return;
    }
    this.parts.push(this.currentPartName);
    this.currentPartName = '';
    this.numberOfPartPages = this.parts.length % 5 == 0 ?
      Math.floor(this.parts.length / 5) : (Math.floor(this.parts.length / 5) + 1);
  }
}
